import { Pipe, PipeTransform } from '@angular/core';
/*
 * Converts from f to Mujer, m to Hombre,
 * and o to Otro
*/
@Pipe({name: 'gender'})
export class GenderPipe implements PipeTransform {
    transform(value: string, args: string[]): any {
        if (!value) return value;
        switch (value) {
            case 'f':
                return 'Mujer';
            case 'm':
                return 'Hombre';
            default:
                return 'Otro';
        }
  }
}



// WEBPACK FOOTER //
// /codebuild/output/src4156872633/src/src/app/pipes/gender.pipe.ts